// extracted by mini-css-extract-plugin
export default {"colorTangelo":"#fc4c02","Preloader":"Preloader_Preloader__Xp-6t","Preloader--screen":"Preloader_Preloader--screen__4WxoR","Preloader--block":"Preloader_Preloader--block__oud-T"};